module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p4"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "chaptertitle paired"
  }, [_vm._v("2005")]), _vm._v(" "), _c('h2', {
    staticClass: "chaptersubtitle "
  }, [_vm._v("Lincoln, Nebraska")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("“Are you lost?” the man asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“No,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Where are you headed?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Seat taken?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“As you can see, it’s empty,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("He sat down across the table. A road map of the lower forty-eight states separated the man and woman. It also joined them in a way.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Wasn’t an invitation,” she said, not pleasantly. Not unpleasantly.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("He ignored the comment. He ate lunch in this diner every day at noon. It felt kind of like home. He didn’t need an invitation to sit down in his own dining room.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“So, let me get this straight. You don’t know where you’re going, but you’re not lost.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“That’s the gist of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“On a road trip?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Something like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You picked a good place to begin a journey. We’re practically smack in the middle of the country.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“And the middle of nowhere,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("He couldn’t argue with that and nodded in agreement. “My name’s Bill.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Hello, Bill.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You got a name?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Everyone has a name.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Bill waited. He was expecting a name. She wasn’t sure which one to use.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Kate,” she said. It felt odd saying her real name again.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“That’s a nice, simple name.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I guess so.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You should be careful, Kate. A woman alone on the road. Never a great idea,” Bill said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I can take care of myself,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Some people, you just don’t know. You don’t know what they’re capable of.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I think I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’ve been around awhile,” Bill said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("She couldn’t argue with him about that. The lines were etched deep on his forehead like a maze of estuaries, with his hair running from the shore. He’d managed to avoid the middle-aged spread, but his gut still seemed a little soft. She knew he meant well. She also knew he’d keep talking because he was tired of hanging on to all that wisdom.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’m sure you have. Can I get the check, please?” she asked the waitress.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“A woman shouldn’t be traveling alone,” Bill continued. “Especially if she’s got no particular destination. I know you think I’m just an old man prattling on and I should mind my own business. But I got a daughter about your age and I would tell her the same thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Has your daughter ever killed a man?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Excuse me?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Kate leaned in and spoke in a whisper so as not to disturb the other patrons. “Has your daughter ever killed a man?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Of course not,” Bill said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I didn’t mean for it to happen, but it did.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Kate said it to silence him. She was surprised how well it worked. It slipped off her tongue so easily this time. She wondered why that was.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Bill placed his hands on the map and traced the Continental Divide.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Kate paid the check and carefully folded up the map. She smiled warmly at Bill, just to ease the tension.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Excuse me. I have to be somewhere.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6d370bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c01.vue
// module id = 72
// module chunks = 0